/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    "Nous avons cherché partout, mais ce contenu n'existe pas. Il a peut-être été supprimé. Il est possible que l'URL contienne une faute de frappe. Vérifiez bien 😉",
  'embedded-confluence-common.src.content.empty-state-header': 'Impossible de trouver ce que vous recherchez',
  'embedded.confluence.already-logged-in-paragraph': "Déjà connecté ? Essayez d'actualiser.",
  'embedded.confluence.footer.hover.text': 'Afficher dans Confluence',
  'embedded.confluence.footer.prefix': 'Optimisé par',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Connexion à Confluence',
  'embedded.confluence.login-page.login-button': 'Connexion à Confluence',
  'embedded.confluence.login-page.login-button.aria-label': 'Bouton de connexion',
  'embedded.confluence.login-page.login-text': 'Vous devez être connecté pour voir cette page',
  'embedded.confluence.login-page.refresh-page-banner':
    "Après la connexion, cette page devrait s'actualiser automatiquement. Si ce n'est pas le cas, cliquez ici pour l'actualiser.",
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Actualiser la page',
  'embedded.confluence.need-to-log-in-paragraph': 'Vous devez être connecté pour voir cette page',
  'embedded.confluence.still-having-trouble-paragraph':
    'Vous rencontrez toujours des problèmes ? Assurez-vous que les cookies tiers sont activés, ou {link}.',
  'embedded.confluence.troubleshooting-link-text': 'reportez-vous à ce guide de dépannage',
  'embedded.confluence.troubleshooting-link.aria-label': 'lien vers le guide de dépannage',
};
